<template>
    <!-- <transition-group name="banner-hide">
        <div id="FLOATING_BANNER_HIDE" v-show=' isHide10min ' key="hide">
            <div class="hide-btn-area"  @click=' hide10min() '>
                <i class="fa fa-eye" aria-hidden="true"></i> Sponsor
            </div>
        </div> -->
    <transition name="banner-hide">
        <div id="FLOATING_BANNER" v-show=' !isHide10min ' key="show">    
            <div class="hide-btn-area"  @click=' hide10min() '>
                <i class="fa fa-eye-slash" aria-hidden="true"></i> 배너 (10분간 숨기기) 
            </div>
            <div class="banners-area">
                <a href="http://chat.devs.co.kr" target="_blank">
                    <img width="100%" src="https://ci6.googleusercontent.com/proxy/BIfoKyuCKYXSIOLfacCVBI76U-nfpuqCrOEBBdOoPnBfMlMUjDd63MUUCH6QaxinDJxWpyueloBdcNDbZBmnEnidMbW8TeHS9PND0k85T4Q21mKQjSYC9kGpuEklUcHehaX57JGn3xxhCYzj6i85k-MoO5PtweDjxc6zFSe_m6BmvbQ7Z1NVepsiA8KeXR0a2gyz-QgayKa8MOOEXXMa1yCW65Wb=s0-d-e1-ft#https://firebasestorage.googleapis.com/v0/b/incheon-devs.appspot.com/o/public%2Fopentalk.png?alt=media&token=33104bfa-8ff6-4c2d-8a84-e410a7e5757a" alt="">
                </a>
            </div>
        </div>
    </transition>
    <!-- </transition-group> -->
</template>

<script>
export default {
    data(){
        return {
            isHide10min: false,
        };
    },
    methods : {
        hide10min(){
            this.isHide10min = !this.isHide10min;
            setTimeout(() => {
                this.isHide10min = !this.isHide10min;
            }, 600000);
            // }, 3000);
        },
    }
    
}
</script>


<style>
/* #FLOATING_BANNER_HIDE {
    position: fixed;
    bottom: 45px; right: 10px;
    width: 40px; height: 200px;
    background: #f7f7f7;
    border: 1px solid #ccc;
    z-index: 999;
} */

#FLOATING_BANNER {
    position: fixed;
    bottom: 45px; right: 10px;
    width: 240px; max-height: 600px;
    background: #f7f7f7;
    border: 1px solid #ccc;
    z-index: 999;
}

#FLOATING_BANNER .hide-btn-area {
    box-sizing: border-box;
    padding: 8px;
    cursor: pointer;
    border-bottom: 1px solid #ccc;
}
#FLOATING_BANNER .hide-btn-area:hover {
    background: #eee;
}

#FLOATING_BANNER .banners-area {
    box-sizing: border-box;
    overflow-x: hidden;
    font-size: 0;
}


.banner-hide-enter-active {
  transition: all 1s ease;
}
.banner-hide-leave-active {
  transition: all 1s ease;
}
.banner-hide-enter{
  transform: translateX(150%);
}
.banner-hide-leave-to{
  transform: translateX(150%);
}
</style>
